import React from "react";
import classes from "./TupleInner.scss";

import FlightInfo from "./FlightInfo/FlightInfo";
import FareInfo from "./FareInfo/FareInfo";
import IntBaggage from './IntBaggage/IntBaggage';

const tupleInner = (props) => {
    
  let tabClassPrimary = [classes.TabItem];
  let tabClassSecondary = [classes.TabItem];
  let tabClassTertiary = [classes.TabItem];

  if (props.tabIndex === 1) {
    tabClassPrimary.push(classes.TabItemActive);
  } else if (props.tabIndex === 2) {
    tabClassSecondary.push(classes.TabItemActive);
  } else if (props.tabIndex === 3) {
    tabClassTertiary.push(classes.TabItemActive);
  }

  return (
    <div className={classes.InnerContainer}>
      <ul className={classes.TabList}>
        <li
          className={tabClassPrimary.join(' ')}
          onClick={(e) => {
            e.stopPropagation();
            props.switchTab(1);
          }}>
          Flight Info
        </li>
        <li
          className={tabClassSecondary.join(' ')}
          onClick={(e) => {
            e.stopPropagation();
            props.switchTab(2);
          }}>
          Fare Rules
        </li>
        {props.isIntFlight ? (
          <li
            className={tabClassTertiary.join(' ')}
            onClick={(e) => {
              e.stopPropagation();
              props.switchTab(3);
            }}>
            Baggage
          </li>
        ) : null}
      </ul>
      <div className={`u-backgroundColorTupleInner`}>
        {
          props.tabIndex === 1 ? 
            <FlightInfo
              flightSchedule={props.flightSchedule}
              cityName={props.cityName}
              cityNames={props.cityNames}
              airlineNames={props.airlineNames}
              airportNames={props.airportNames}
              isIntFlight={props.isIntFlight}
              /> : 
          props.tabIndex === 2 ? 
            <FareInfo 
              proceed={props.proceedToBookHandler}
              stack={props.stackHandler}
              fareDetails={props.fareDetails}
              fareRules={props.fareRules}
              isIntFlight={props.isIntFlight} /> : 
          props.tabIndex === 3 ? 
            <IntBaggage 
              baggageData={props.intBaggage} /> : null
        }  
      </div>
    </div>
  );
}

export default tupleInner;



// WEBPACK FOOTER //
// ./src/components/Flight/Tuple/TupleInner/TupleInner.js